var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollablePage",staticClass:"responsive-layout",class:_vm.background,attrs:{"id":"scrollablePage"}},[_c('div',{staticClass:"responsive-page",class:_vm.background},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }